import React from 'react';
import MuiDivider from '@mui/material/Divider';

const Divider = (props) => <MuiDivider {...props} />;

export default Divider;
